export const VUEX_APP_INIT = 'VUEX_APP_INIT'
export const VUEX_APP_INITIALIZED = 'VUEX_APP_INITIALIZED'
